import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "id", "size", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Heading from 'components/Heading';
import { usePanelTitleId } from './PanelWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
var PanelTitle = function PanelTitle(_ref) {
  var as = _ref.as,
    id = _ref.id,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'extra-small' : _ref$size,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var panelTitleId = usePanelTitleId(id);
  var Component = Heading;
  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({
    as: as || 'h3',
    size: size,
    id: panelTitleId,
    lineHeight: 1.4,
    display: "block"
  }, otherProps), {}, {
    children: children
  }));
};
export default PanelTitle;